//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    UNITTYPE_EVENT_CREATE_REQUEST,
    UNITTYPE_EVENT_EDIT_REQUEST,
    UNITTYPE_EVENT_GET_REQUEST,
    UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST
} from 'Redux/actionTypes';

//Actions
import {
    unitTypeEventCreateResult,
    unitTypeEventEditResult,
    unitTypeEventGetResult,
    unitTypeEventSearchUnitTypeResult,

} from 'Redux/actions';

function* getUnitTypeEvent({ payload }) {
    try {
        
        let QUERY = `
            query getUnitTypeEvent ($id: Int!) {
                result: getUnitTypeEvent (id: $id) {
                    id
                    unitTypeId
                    rawEvent
                    eventId
                    active
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(unitTypeEventGetResult(data.result))

    } catch (exc) {
        yield put(unitTypeEventGetResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditUnitTypeEvent/redux/saga', 'getUnitTypeEvent');
    }
}

function* createUnitTypeEvent({ payload }) {
    try {
        let QUERY = `
            mutation createUnitTypeEvent ($eventId: Int!, $unitTypeId: Int!, $rawEvent: String!, $active: Boolean) {
                result: createUnitTypeEvent (eventId: $eventId, unitTypeId: $unitTypeId, rawEvent: $rawEvent, active: $active) {
                    id
                    eventId
                    unitTypeId
                    rawEvent
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(unitTypeEventCreateResult(data?.result))
        } else yield put(unitTypeEventCreateResult())

    } catch (exc) {
        yield put(unitTypeEventCreateResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditUnitTypeEvent/redux/saga', 'createUnitTypeEvent', true);
    }
}

function* updateUnitTypeEvent({ payload }) {
    try {
        let QUERY = `
            mutation updateUnitTypeEvent ($id: Int!, $eventId: Int!, $unitTypeId: Int!, $rawEvent: String!, $active: Boolean) {
                result: updateUnitTypeEvent (id: $id, eventId: $eventId, unitTypeId: $unitTypeId, rawEvent: $rawEvent, active: $active) {
                    id
                    unitTypeId
                    rawEvent
                    eventId
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(unitTypeEventEditResult(data?.result));

    } catch (exc) {
        yield put(unitTypeEventEditResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditUnitTypeEvent/redux/saga', 'updateUnitTypeEvent');
    }
}

function* searchUnitTypeEvents({ payload }) {
    try {
        let QUERY = `
            query searchUnitTypeEvents ($conditions: [UnitTypeEventSearchInput], $sort: [UnitTypeEventSortInput], $limit: Int, $offset: Int) {
                result: searchUnitTypeEvents (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        unitTypeId
                        rawEvent
                        splitEventIndex
                        splitEventValue
                        eventId
                        event {
                            id
                            name
                            color
                        }
                        active
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(unitTypeEventGetResult(data.result))
    } catch (exc) {
        yield put(unitTypeEventSearchUnitTypeResult())
        ExceptionManager(exc, 'Modules/events/views/.components/createEditUnitTypeEvent/redux/saga', 'searchUnitTypeEvents');
    }
}

function* watchEventRequests() {
    yield takeEvery(UNITTYPE_EVENT_GET_REQUEST, getUnitTypeEvent);
    yield takeEvery(UNITTYPE_EVENT_CREATE_REQUEST, createUnitTypeEvent);
    yield takeEvery(UNITTYPE_EVENT_EDIT_REQUEST, updateUnitTypeEvent);
    yield takeEvery(UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST, searchUnitTypeEvents);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchEventRequests)
    ]);
}